module.exports = __webpack_public_path__ + "static/media/4641.b7dd2b67.jpg";